// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--B1Yng";
export var Link = "styles-module--Link--txVYP";
export var Message = "styles-module--Message--lKoG6";
export var Wrapper = "styles-module--Wrapper--N7dAk";